// Hooks
import { useAppSelector } from '../../../app/hooks';

// Features
import {
    selectSession,
    selectCurrentGame,
} from '../../../features/session/sessionSlice';

// Components
import SessionScreen from '../../organisms/SessionScreen/SessionScreen';
import PatternWinners from '../../molecules/PatternWinners/PatternWinners';
import SessionIdle from '../../molecules/SessionIdle/SessionIdle';

/**
 * @function PatternWon
 * List of users of a mid-game pattern win
 *
 * @example
 * return (
 *   <PatternWon />
 * )
 */
function PatternWon(): JSX.Element {
    const session = useAppSelector(selectSession);
    if (session === null || session === undefined) return <></>;
    const game = useAppSelector(selectCurrentGame);
    const gameMeta = session?.games.find(({ id }) => id === game?.id);
    if (gameMeta === undefined) return <></>;

    return (
        <SessionScreen>
            <SessionIdle heading={`Pattern Won`}>
                <PatternWinners gameMeta={gameMeta} winners={game.winners} />
            </SessionIdle>
        </SessionScreen>
    );
}

// Exports
export default PatternWon;
